import { ALTERAR_REGISTROS_POR_PAGINA_ENCOMENDA } from '../types'

export default function alterarRegistrosPorPaginaEncomenda (valor) {
  return {
    type: ALTERAR_REGISTROS_POR_PAGINA_ENCOMENDA,
    payload: valor
  }
}
